/**
 * The SPELLING-FREE form of a caller-supplied map key: lower case, with every `_` and `-`
 * removed, so `customer_name`, `customerName`, `CUSTOMER-NAME` and `CustomerName` are one key.
 *
 * It exists for one comparison: is this key one of a set of WHOLE names the caller may not
 * use. Two sets ask it — the identity credentials (`identity-credential-keys.ts`) and the
 * reserved identity names of the public v1 chat door (`SendChatMessageMetadataSchema`) — and
 * they must agree on what "the same name" means, or one door refuses a spelling the other
 * lets through. Compare a key's normalised form against a set of normalised names, never a
 * substring: `customer_email_verified` normalises to `customeremailverified`, which is not
 * `customeremail`.
 */
export function normaliseKeySpelling(key: string): string {
  return key.toLowerCase().replace(/[_-]/g, "");
}
